import React, { useState, useEffect } from 'react';
import { AppProvider } from './context/AppContext';
import { DarkModeProvider } from './components/DarkMode';
import { ThemeProvider } from './components/ThemeSelector';
import { PinUnlock } from './components/PinLock';
import InstallPrompt from './components/InstallPrompt';
import HomeScreen from './screens/HomeScreen';
import CalendarScreen from './screens/CalendarScreen';
import StatisticsScreen from './screens/StatisticsScreen';
import AchievementsScreen from './screens/AchievementsScreen';
import SettingsScreen from './screens/SettingsScreen';
import JournalScreen from './screens/JournalScreen';
import WeeklyReportScreen from './screens/WeeklyReportScreen';
import { BookOpen, BarChart2, Heart, Zap, Settings } from 'lucide-react';

const SCREENS = {
  home: HomeScreen,
  journal: JournalScreen,
  report: WeeklyReportScreen,
  calendar: CalendarScreen,
  stats: StatisticsScreen,
  achievements: AchievementsScreen,
  settings: SettingsScreen,
};

const NAV_ITEMS = [
  { id: 'home', label: 'בית', Icon: Heart },
  { id: 'journal', label: 'יומן', Icon: BookOpen },
  { id: 'report', label: 'דוח', Icon: BarChart2 },
  { id: 'achievements', label: 'הישגים', Icon: Zap },
  { id: 'settings', label: 'הגדרות', Icon: Settings },
];

const App = () => {
  const [currentScreen, setCurrentScreen] = useState('home');
  const [locked, setLocked] = useState(
    localStorage.getItem('app_pin_enabled') === 'true'
  );
  const Screen = SCREENS[currentScreen];

  if (locked) {
    return (
      <ThemeProvider>
        <PinUnlock onUnlock={() => setLocked(false)} />
      </ThemeProvider>
    );
  }

  return (
    <ThemeProvider>
      <DarkModeProvider>
        <AppProvider>
          <div dir="rtl" className="max-w-md mx-auto min-h-screen bg-white relative">
            <InstallPrompt />
            <Screen navigate={setCurrentScreen} />
            <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-stone-200 px-2 py-2 shadow-lg z-50">
              <div className="max-w-md mx-auto flex justify-around">
                {NAV_ITEMS.map(({ id, label, Icon }) => (
                  <button
                    key={id}
                    onClick={() => setCurrentScreen(id)}
                    className={`flex flex-col items-center gap-1 p-2 rounded-lg transition-all ${
                      currentScreen === id ? 'text-brand-500' : 'text-stone-400 hover:text-brand-400'
                    }`}
                  >
                    <Icon className="w-6 h-6" />
                    <span className="text-xs font-semibold">{label}</span>
                  </button>
                ))}
              </div>
            </nav>
          </div>
        </AppProvider>
      </DarkModeProvider>
    </ThemeProvider>
  );
};

export default App;
